module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "technical-info"
  }, [_c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__medium"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Motor\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Mærkning",
      "value": _vm.$store.state.carData.general.MotorMaerkning
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Drivkraft",
      "value": _vm.$store.state.carData.general.DrivkraftTypeNavn
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Brændstofforbrug",
      "value": _vm.$store.state.carData.general.MotorKmPerLiter,
      "suffix": "km/l"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Elektrisk forbrug",
      "value": _vm.$store.state.carData.general.MotorElektriskForbrug,
      "suffix": "km/l"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Max hastighed",
      "value": _vm.$store.state.carData.general.MaksimumHastighed,
      "suffix": "km/t"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Slagvolumen",
      "value": _vm.$store.state.carData.general.MotorSlagVolumen,
      "suffix": "cm<sup>3</sup>"
    }
  }, [(_vm.$store.state.carData.general.MotorStoerrelse) ? _c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            (" + _vm._s(_vm.$store.state.carData.general.MotorStoerrelse) + "L)\n                        ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Største effekt",
      "value": _vm.$store.state.carData.general.MotorStoersteEffekt,
      "suffix": "kW"
    }
  }, [_c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            (~" + _vm._s(_vm._f("rounded")(_vm.$store.state.carData.general.MotorStoersteEffekt * 1.3636363636)) + " HK)\n                        ")])]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Antal cylindre",
      "value": _vm.$store.state.carData.general.MotorCylinderAntal
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Vægt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Teknisk totalvægt",
      "value": _vm.$store.state.carData.general.TekniskTotalVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Totalvægt",
      "value": _vm.$store.state.carData.general.TotalVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Egenvægt",
      "value": _vm.$store.state.carData.general.EgenVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Køreklar vægt (min.)",
      "value": _vm.$store.state.carData.general.KoereklarVaegtMinimum,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Tilkoblingsmulighed",
      "value": _vm.$store.state.carData.general.Tilkoblingsmulighed
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Vogntogsvægt",
      "value": _vm.$store.state.carData.general.VogntogVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Påhængsvogn totalvægt",
      "value": _vm.$store.state.carData.general.PaahaengVognTotalVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Påhængskøretøj med bremser",
      "value": _vm.$store.state.carData.general.TilkoblingsvaegtMedBremser,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Påhængskøretøj uden bremser",
      "value": _vm.$store.state.carData.general.TilkoblingsvaegtUdenBremser,
      "suffix": "kg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Udstyr\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.$store.state.carData.general.KoeretoejUdstyrSamling), function(equipment) {
    return (_vm.$store.state.carData.general.KoeretoejUdstyrSamling.length > 0) ? _c('div', {
      staticClass: "equipment"
    }, [_vm._v("\n                        " + _vm._s(equipment) + "\n                    ")]) : _vm._e()
  }), _vm._v(" "), (_vm.$store.state.carData.general.KoeretoejUdstyrSamling.length === 0) ? _c('div', [_vm._v("\n                        -\n                    ")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "column column__medium"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Aksler\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Antal",
      "value": _vm.$store.state.carData.general.AkselAntal
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Afstand",
      "value": _vm.$store.state.carData.general.AkselAfstand,
      "suffix": "mm"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Trækkende aksler",
      "value": _vm.$store.state.carData.general.TraekkendeAksler
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Største tryk",
      "value": _vm.$store.state.carData.general.StoersteAkselTryk,
      "suffix": "kg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Karrosseri\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Type",
      "value": _vm.$store.state.carData.general.KarrosseriTypeNavn
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Antal døre",
      "value": _vm.$store.state.carData.general.AntalDoere
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Siddepladser (min.)",
      "value": _vm.$store.state.carData.general.SiddepladserMinimum
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Fælge / dæk",
      "value": _vm.$store.state.carData.general.FaelgDaek
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Sporvidde (forrest)",
      "value": _vm.$store.state.carData.general.SporviddenForrest,
      "suffix": "mm"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Sporvidde (bagerst)",
      "value": _vm.$store.state.carData.general.SporviddenBagest,
      "suffix": "mm"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Placering af stelnummer",
      "value": _vm.$store.state.carData.general.StelNummerAnbringelse
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Miljøoplysninger\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "CO<sub>2</sub>-udslip",
      "value": _vm.$store.state.carData.general.MiljoeOplysningCO2Udslip,
      "suffix": "g"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "CO",
      "value": _vm.$store.state.carData.general.MiljoeOplysningEmissionCO,
      "suffix": "g/km"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "HC+NOX",
      "value": _vm.$store.state.carData.general.MiljoeOplysningEmissionHCPlusNOX,
      "suffix": "g/km"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "NOX",
      "value": _vm.$store.state.carData.general.MiljoeOplysningEmissionHCPlusNOX,
      "suffix": "g/km"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Partikelfilter",
      "value": _vm.$store.state.carData.general.MiljoeOplysningPartikelFilter
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Røgtæthed",
      "value": _vm.$store.state.carData.general.MiljoeOplysningRoegtaethed,
      "suffix": "m-1"
    }
  }, [(_vm.$store.state.carData.general.MiljoeOplysningRoegtaethedOmdrejningstal > 0) ? _c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            v. " + _vm._s(_vm.$store.state.carData.general.MiljoeOplysningRoegtaethedOmdrejningstal) + " o/m\n                        ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Partikler",
      "value": _vm.$store.state.carData.general.MiljoeOplysningPartikler,
      "suffix": "g/km"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Kørselsstøj",
      "value": _vm.$store.state.carData.general.MotorKoerselStoej,
      "suffix": "dB"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Standstøj",
      "value": _vm.$store.state.carData.general.MotorStandStoej,
      "suffix": "dB"
    }
  }, [(_vm.$store.state.carData.general.MotorStandStoejOmdrejningstal > 0) ? _c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            v. " + _vm._s(_vm.$store.state.carData.general.MotorStandStoejOmdrejningstal) + " o/m\n                        ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Euronorm",
      "value": _vm.$store.state.carData.general.NormTypeNavn
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Sikkerhed\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("\n                            Euro NCAP testet\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.$store.state.carData.general.NCAPTest) ? _c('span', [_vm._v("Ja")]) : _c('span', [_vm._v("Nej")])])]), _vm._v(" "), (_vm.$store.state.carData.general.NCAPTest) ? _c('div', [_c('a', {
    staticClass: "block-cta",
    staticStyle: {
      "font-weight": "600",
      "color": "#00c3ae"
    },
    attrs: {
      "href": 'https://www.euroncap.com/en/search-results/?query=' + _vm.$store.state.carData.general.MaerkeTypeNavn + '+' + _vm.$store.state.carData.general.ModelTypeNavn,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n                            Søg efter NCAP test her\n                        ")])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2fa15fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/pages/technical-info.vue
// module id = 358
// module chunks = 1